import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import vueCookie from 'vue-cookie';
import AuthLogin from '@/components/common/AuthLogin';
import AccessDeny from '@/components/common/AccessDeny';
import VueLocalStorage from 'vue-ls';
import _ from "lodash";
import {importCurentUserRoles} from "@/helpers/user";

import AdgroupReport  from '@/components/AdgroupReport';
import AdgroupReport2 from '@/components/AdgroupReport2';
import Tools from '@/components/Tools';
import Management from '@/components/Management';
import Notes from '@/components/Notes';
import SellingPartnersReport from '@/components/SellingPartnersReport';
import RevenuePartnersReport from '@/components/RevenuePartnersReport';
import RawDataPartnersReport from '@/components/RawDataPartnersReport';
import HourlyPartnersReport  from '@/components/HourlyPartnersReport';
import ScrubRateHourlyReport from '@/components/ScrubRateHourlyReport';
import TargetReport          from '@/components/TargetReport';
import Homepage              from '@/components/Homepage';

Vue.use(Router);

Vue.use(VueLocalStorage, {
  namespace: 'clickscontrol_'
});

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: AuthLogin,
      meta: {
        title: 'Log In',
      }
    },
    {
      path: '/accessDeny',
      name: 'accessDeny',
      component: AccessDeny,
      meta: {
        title: 'Access Denied',
        requiresAuth: true
      }
    },
    {
      path: '/',
      redirect: '/homepage'
    },
    {
      path: '/homepage',
      component: Homepage,
      props: (route) => ({ query: route.params.filters }),
      meta: {
        title: 'Homepage',
        requiresAuth: true
      }
    },    
    {
      path: '/adgroupReport',
      name: 'AdgroupReport',
      component: AdgroupReport,
      props: (route) => ({ query: route.params.filters }),
      meta: {
        title: 'Adgroup Report',
        requiresAuth: true
      }
    },
    {
      path: '/adgroupReport2',
      name: 'AdgroupReport2',
      component: AdgroupReport2,
      props: (route) => ({ query: route.params.filters }),
      meta: {
        requiresAuth: true,
        title: "AdGroup Report"
      }
    },
    {
      path: '/sellingPartnerReport',
      name: 'SellingPartnersReport',
      component: SellingPartnersReport,
      props: (route) => ( route.query ),
      meta: {
        title: 'Selling Partners Report',
        requiresAuth: true
      }
    },
    {
      path: '/hourly/:adgroupName',
      name: 'hourly'
    },
    {
      path: '/history',
      name: 'history'
    },
    {
      path: '/tools',
      name: 'tools',
      component: Tools,
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/management',
      name: 'management',
      component: Management,
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/notes',
      name: 'notes',
      component: Notes,
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/revenuePartnersReport',
      name: 'revenuePartnersReport',
      component: RevenuePartnersReport,
      meta: {
        title: 'Revenue Partners Report',
        requiresAuth: true
      },
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/rawDataPartnersReport',
      name: 'rawDataPartnersReport',
      component: RawDataPartnersReport,
      meta: {
        title: 'Raw Data Partners Report',
        requiresAuth: true
      },
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/hourlyPartnersReport',
      name: 'hourlyPartnersReport',
      component: HourlyPartnersReport,
      meta: {
        title: 'Hourly Partners Report',
        requiresAuth: true
      },
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/scrubRateHourlyReport',
      name: 'scrubRateHourlyReport',
      component: ScrubRateHourlyReport,
      meta: {
        title: 'Scrubrate Report',
        requiresAuth: true
      },
      props: (route) => ({ query: route.params.filters })
    },
    {
      path: '/targetReport',
      name: 'targetReport',
      component: TargetReport,
      meta: {
        title: 'Target Report',
        requiresAuth: true,
        roles: [
          'PERMISSION_TARGET_REPORT'
        ]
      },
      props: (route) => ({ query: route.params.filters })
    }
  ]
});

router.afterEach( to => {
  let title = _.get(to, 'meta.title');
  if( _.isString(title) ) {
    document.title = title;
  }
});

router.beforeEach((to, from, next) => {
  document.title = 'loading...';

  if (to.matched.some(record => record.meta.requiresAuth))
  {
    let isAuthorized = store.getters['isUserAuthorized'];
    let isAuthorizedCookieExists = vueCookie.get('authToken');

    if ((isAuthorized !== undefined && isAuthorized !== null) || (isAuthorizedCookieExists !== undefined && isAuthorizedCookieExists !== null))
    {
        if (to.path !== from.path)
        {
          importCurentUserRoles().then(( roles ) => {
            let pass = true;
            if( _.isArray(to.meta.roles) ) {
              pass = _.difference(to.meta.roles, roles).length === 0;
            }

            if( pass ) {
              next();
            } else {
              next({
                path: '/accessDeny',
                query: { redirect: to.fullPath }
              });
            }
          })
        }
        else
        {
            next();
        }
    }
    else
    {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  }
  else
  {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js